interface V3IconNewsletterProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconNewsletter = ({ stroke = "#ABB0BA", ...rest }: V3IconNewsletterProps) => <svg width="24" height="24" {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m3 7 9 6 9-6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
